module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/clip/close_modal-ed8b472ae63cae121dd4ff4c54bb28f2.png";